
if (!elmApp) {
  var elmApp = Elm.Main.fullscreen({
      language : ofptmes_config.language,
      uiKeyVals: ofptmes_config.uiKeyVals,
      baseUrl: ofptmes_config.baseUrl,
      authToken: localStorage.getItem('wpisession') || ""
  });
}


elmApp.ports.storeSession.subscribe(function(session) {
  localStorage.wpisession = session;
});


elmApp.ports.openLink.subscribe(function(linkData) {
  var xhr = new XMLHttpRequest();
  xhr.responseType = "blob";
  xhr.open("GET", linkData.url, true); // true for asynchronous
  xhr.setRequestHeader("Authorization", "Bearer " + linkData.token);
  xhr.onload = function() {
      var blob = xhr.response;
      if (blob) {
          try {
              fileObjectURL = URL.createObjectURL(blob);
              window.open(fileObjectURL);
          }
          catch(e) {}
      }
  }
  xhr.send(null);
});


window.addEventListener("storage", function(event) {
  if (event.storageArea === localStorage && event.key === "wpisession") {
    elmApp.ports.onSessionChange.send(event.newValue);
  }
}, false);



elmApp.ports.getAreaAndPlace.subscribe(function(geom) {
  function checkCurrentYear(result) {
    return result.attributes.is_current_jahr == true;
  }

  function getAndSendAreaPlace(area, request) {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
          var res = JSON.parse(this.response);
          var filteredPlaces = res.results.filter(checkCurrentYear);
          var place = filteredPlaces[0].attributes.gemname;
          if (area)
            elmApp.ports.inboundArea.send(area);
          elmApp.ports.inboundPlace.send(place);
      }
    };
    xhttp.open("GET", request, true);
    xhttp.send();
  };

  try {
      var center = [];
      var area = undefined;

      // If Point Else Polygon
      if (geom.coordinates.length == 2) {
        var newPoint = new ol.geom.Point(geom.coordinates);
        var extent = newPoint.getExtent();
        center = ol.extent.getCenter(extent);
      } else {
        var newPolygon = new olGeomFunc(geom.coordinates);
        var extent = newPolygon.getExtent();
        area = Math.round(newPolygon.getArea());
        center = ol.extent.getCenter(extent);
      }
      const request = 'https://api3.geo.admin.ch/rest/services/all/MapServer/identify?' +
          'geometry=' + center[0] + ',' + center[1] + '&geometryType=esriGeometryPoint&imageDisplay=1920,846,96&' +
          'lang=fr&sr=2056&layers=all:ch.swisstopo.swissboundaries3d-gemeinde-flaeche.fill&mapExtent=312250,-77500,1007750,457500&tolerance=0&returnGeometry=false';
      getAndSendAreaPlace(area, request);

  }
  catch(err) {
    console.log(err);
  }
});


elmApp.ports.getPlaces.subscribe(function(string) {
  function checkCanton(result) {
    return (result.attributes.kanton =="VD");
  }
  function getName(place) {
    return place.attributes.gemname;
  }
  function sendPlaceList(request) {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
          var res = JSON.parse(this.response);
          console.log(res.length);
          console.log(res);
          var filteredPlaces = res.results.filter(checkCanton);
          console.log(filteredPlaces);
          var placeNames = filteredPlaces.map(getName);
          elmApp.ports.inboundPlaceList.send(placeNames);
      }
    };
    xhttp.open("GET", request, true);
    xhttp.send();
  };

  try {
      const request = 'https://api3.geo.admin.ch/rest/services/all/MapServer/identify?' +
          'geometryType=esriGeometryEnvelope&geometry=2490000,1110000,2590000,1210000&imageDisplay=1920,846,96&' +
          'lang=fr&sr=2056&layers=all:ch.swisstopo.swissboundaries3d-gemeinde-flaeche.fill&mapExtent=312250,-77500,1007750,457500&tolerance=0&returnGeometry=false';
      //sendPlaceList(request);

      const request2 = 'https://api3.geo.admin.ch/rest/services/api/MapServer/find?' +
          'layer=ch.swisstopo.swissboundaries3d-gemeinde-flaeche.fill&' +
          'searchText=2024&searchField=jahr&returnGeometry=false';

      sendPlaceList(request2);

  }
  catch(err) {
    console.log(err);
  }

});



elmApp.ports.getZone.subscribe(function(geom) {
  function getAndSendZone(request) {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
          var res = JSON.parse(this.response);
          var zone = res.results[0].attributes.gemname;
          elmApp.ports.inboundZone.send(zone);
      }
    };
    xhttp.open("GET", request, true);
    xhttp.send();
  };

  try {
      var newpolygon = new ol.geom.Polygon(geom.coordinates);
      var extent = newpolygon.getExtent();
      var center = ol.extent.getCenter(extent);
      var request = 'https://api3.geo.admin.ch/rest/services/all/MapServer/identify?' +
          'geometry=' + center[0] + ',' + center[1] + '&geometryType=esriGeometryPoint&imageDisplay=1920,846,96&' +
          'lang=fr&sr=2056&layers=all:ch.blw.landwirtschaftliche-zonengrenzen&mapExtent=312250,-77500,1007750,457500&tolerance=0&returnGeometry=false';
      getAndSendZone(request);
  }
  catch(err) {}

});

// lien vers cadastre PROVISOIRE

elmApp.ports.getPlotData.subscribe(function(coordinates) {
  var request = 'https://api3.geo.admin.ch/rest/services/all/MapServer/identify?' +
      'geometry=' + coordinates.x + ', '+ coordinates.y +'&geometryType=esriGeometryPoint&imageDisplay=1920,846,96&' +
      '&lang=en&layers=all:ch.kantone.cadastralwebmap-farbe&mapExtent=312250,-77500,1007750,457500&returnGeometry=true&geometryFormat=geojson&sr=2056&tolerance=0'
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
            var res = JSON.parse(this.response);
            if ( res && res.results.length > 0) {
              var canton = res.results[0].properties.ak;
              var geom = res.results[0].geometry;
              var extent = res.results[0].bbox;
              sendItemsBack( canton, coordinates, extent, geom);
            }
        }
    };
    xhttp.open("GET", request, true);
    xhttp.send();
});

function sendItemsBack( canton, coordinates, extent, geom ) {
  var url = '';
  switch(canton) {
      case 'VD': // 21781 coord en km
          url = "http://www.geo.vd.ch/theme/cadastre_thm?map_x=" + coordinates.x + "&map_y=" + coordinates.y + "&map_zoom=10";
          break;
      case 'FR': // 21781
          url = "https://map.geo.fr.ch/?dataTheme=Mensuration%20officielle&extent=" + extent[0] + "," + extent[1] + "," + extent[2] + ","+ extent[3] + "&lang=fr";
          break;
      case 'GE': // 21781 >>  2056 conversion auto
          url = "https://www.etat.ge.ch/geoportail/pro/?mapresources=CADASTRE&extent=" + extent[0] + "," + extent[1] + "," + extent[2] + ","+ extent[3];
          break;
      case 'NE': // 2056
          url = "http://sitn.ne.ch/theme/cadastre?map_x=" + (2000000 + coordinates.x) + "&map_y=" + (1000000 + coordinates.y) + "&map_zoom=10";
          break;
      case 'JU': // 2056
          url = "https://geo.jura.ch/theme/Cadastre?&map_x=" + (2000000 + coordinates.x) + "&map_y=" + (1000000 + coordinates.y) + "&map_zoom=8";
          break;
      case 'BE': // 21781
          url = "http://webmap.be-geo.ch/geodaten.php?lang=fr&recenter_bbox=" + extent[0] + "," + extent[1] + "," + extent[2] + ","+ extent[3];
      default:
          break;
  }

  if (url != "") {
    elmApp.ports.inboundPlot.send({ canton: canton, url: url, geom: geom });
  }
};


elmApp.ports.getExtent.subscribe(function(incoming) {
var output = [];
var overallExtent;
for (var i =0; i< incoming.geoObjs.length; i++) {
    var geoObj = incoming.geoObjs[i];
    var newpolygon = new ol.geom.Polygon(geoObj.obj.coordinates);
    var extent = newpolygon.getExtent();
    if (!overallExtent) {
      overallExtent = extent;
    }
    else {
      overallExtent = ol.extent.extend(overallExtent, extent);
    }
}
var center = ol.extent.getCenter(overallExtent);
newParams =
  { extent :
      { minx : overallExtent[0]
      , miny : overallExtent[1]
      , maxx : overallExtent[2]
      , maxy : overallExtent[3]
      }
  , center :
      { x : center[0]
      , y : center[1]
      }
  , zoom : 12.0
  , geoZones : incoming.geoZones
  };

setTimeout(function(){
  elmApp.ports.inboundInitParams.send( newParams );
}, 500);

});


elmApp.ports.exportData.subscribe(function(object) {
  try {
    var target = object.target;
    var geojson = object.dataset;
    var filename = object.filename + target;
    var blob;
    
    if(target == ".xlsx" || target == ".csv") {
      var dataToConvert = JSON.parse(geojson);
      const worksheet = XLSX.utils.json_to_sheet(dataToConvert);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
      if(target == ".xlsx"){
        XLSX.writeFile(workbook, filename);
      }
      else {
        XLSX.writeFile(workbook, filename, { bookType: "csv" });
      }
    }
    else {
      blob = new Blob([geojson], { type: 'text/json;charset=utf-8;' });
      var link = document.createElement('a');
      var url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
  catch(err) {}
});


elmApp.ports.invokeJS.subscribe(function(elmdata) {
  window[elmdata.funcName](elmdata.initData);
});

function exportPDFWithElmData(elmdata) {
  (async() => {
    console.log("exportPDFWithElmData");
    await exportPDFData('tree.pdf', {
      isolatedTree: elmdata.isolatedTree,
      mainMap: elmdata.mapCaptureModel.image,
      treePictureURL: elmdata.image
    });
    elmApp.ports.inboundInvokeJSDone.send({err: null, value: null});
  })();
};
